import { Component } from '@angular/core';
import { NavigationService } from 'src/app/core/services/navigation.service';

@Component({
  selector: 'app-termandprivacypolicy',
  templateUrl: './termandprivacypolicy.component.html',
  styleUrls: ['./termandprivacypolicy.component.scss']
})
export class TermandprivacypolicyComponent {

   constructor(
      private navigationService: NavigationService
    ) { }

   onNavigate(dt: string) {
    switch (dt) {
      case 'privacyPolicy': {
        this.navigationService.openInNewTab('privacy-policy', true);
        break;
      }
      case 'tnc': {
        this.navigationService.openInNewTab('term-conditions', true);
        break;
      }
      default: {
        this.navigationService.navigateByUrl("/");
        break;
      }
    }
  }
}
